const breadcrumbsHome = { name: 'Home', pathName: '/' }

export default [
  {
    path: '/sessions',
    component: () => import('@/modules/session/Sessions.vue'),
    meta: {
      title: 'Gerenciar Usuários',
      breadcrumbs: [breadcrumbsHome]
    }
  }
]
